module.exports = __webpack_public_path__ + "img/订单.7ce59e20.svg";